import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col, Table, Button, Card, CardHeader, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import _ from "lodash";

import DefaultDataGrid from "modules/5_view_helpers/web/DefaultDataGrid";
import columns from "./columns";

// Helpers
import NotAuthorized from "modules/5_view_helpers/web/NotAuthorized";
import HasRole from "modules/5_view_helpers/HasRole";

// Actions
import { getProjectCommunicationsOutgoingTypes } from "../actions";

function mapStateToProps(state) {
  return {
    project_communications_outgoing_types: state.project_communications_outgoing_types,
  };
}

const ProjectCommunicationsOutgoingTypesIndex = (props) => {
  useEffect(() => {
    props.getProjectCommunicationsOutgoingTypes();
  }, []);

  const { project_communications_outgoing_types } = props;

  const readRole = HasRole({ resource_type: "Project::Communications::OutgoingType", name: ["read", "moderator"] });
  const createRole = HasRole({ resource_type: "Project::Communications::OutgoingType", name: ["create", "moderator"] });
  const updateRole = HasRole({ resource_type: "Project::Communications::OutgoingType", name: ["update", "moderator"] });

  if (!readRole) {
    return <NotAuthorized />;
  } else {
    return (
      <Card>
        <CardHeader>
          <Row>
            <Col>
              <h3>Outgoing types</h3>
            </Col>
          </Row>
        </CardHeader>

        <CardBody>
          {createRole && (
            <Row>
              <Col>
                <Link to={`/project/communications/outgoing_types/new`}>
                  <Button color="primary" size="md">
                    <i className="fa fa-plus"> Create New Outgoing type</i>
                  </Button>
                </Link>
              </Col>
            </Row>
          )}

          <Row className="mt-2">
            <Col>
              <DefaultDataGrid columns={columns(updateRole)} data={project_communications_outgoing_types} />
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  }
};
export default connect(mapStateToProps, { getProjectCommunicationsOutgoingTypes })(ProjectCommunicationsOutgoingTypesIndex);
